var ProductSlider = class extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll('.slider-button');
    this.buttons.forEach(item => {
      item.addEventListener('click', this.handleButtonClick.bind(this));
    });

    this.sliders = this.querySelectorAll('.product-slider');
    this.sliders.forEach((slider, idx) => {
      this.loadSlider(slider, idx);
    });
  }

  handleButtonClick() {
    const el = event.target;
    const id = el.dataset.id;

    if (el.classList.contains('opacity-50')) {
      this.querySelector('.slider-button').classList.add('opacity-50');
      this.querySelectorAll('.slider-button').forEach(button => {
        if (!button.classList.contains('opacity-50')) button.classList.add('opacity-50');
      });
      el.classList.remove('opacity-50');

      this.querySelectorAll('.slider-arrows').forEach(arrows => {
        if (!arrows.classList.contains('hidden')) arrows.classList.add('hidden');
      });
      this.querySelector(`.slider-arrows[data-id="${id}"]`).classList.remove('hidden');

      this.querySelectorAll('.product-slider').forEach(arrows => {
        if (!arrows.classList.contains('hidden')) arrows.classList.add('hidden');
      });
      this.querySelector(`.product-slider[data-id="${id}"]`).classList.remove('hidden');
    }
  }

  loadSlider(slider, idx) {
    const prevEl = this.querySelector(`.swiper-button-prev[data-id="${idx}"]`);
    const nextEl = this.querySelector(`.swiper-button-next[data-id="${idx}"]`);

    const productSlider = new Swiper(slider, {
      slidesPerView: 'auto',
      loop: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      breakpoints: {
        1024: {
          slidesPerView: 4
        }
      }
    });
  }
}

customElements.define('product-slider', ProductSlider);